import * as StudioApiImport from './api/endpoints'

export const StudioApi = StudioApiImport
